import { createAction } from '@ngrx/store';

export const lockPreTripPage = createAction('[Home] Lock PreTrip Page');
export const unlockPreTripPage = createAction('[Home] Unlock PreTrip Page');
